import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import DigitalMarketingBangalore from "../components/blogs/DigitalMarketingBangalore";

const DigitalMarketingAgencyBangalore = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.search) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <title>Digital Marketing Agency in Bangalore | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Partner with a trusted digital marketing company in Bangalore. SMS ZOO ZOO offers SEO, paid ads, and growth-focused marketing strategies."
        />

        <meta name="robots" content="index, follow" />
        <link
          rel="canonical"
          href="https://www.smszoozoo.com/digital-marketing-agency-bangalore"
        />
      </Helmet>

      <Navbar />
      <DigitalMarketingBangalore />
      <Footer />
    </>
  );
};

export default DigitalMarketingAgencyBangalore;
